import React, { useEffect, useState } from "react";
import { getAllCategoriesApi } from "@/api/adminApis/adminApis";
import { GenericMultiSelect } from "./GenericMultiSelect";
import Toast from "@/utils/toastManager";


export function CategoriesDropdown({ value = [], onChange, label = "Category" }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await getAllCategoriesApi();
        if (res?.success && Array.isArray(res.data)) {
          setCategories(res.data);
        }
      } catch (err) {
        Toast.error("Failed to fetch categories");
      }
    };
    fetchCategories();
  }, []);

  return (
    <GenericMultiSelect
      sectionLabel={label}
      inputLabel="Select Categories"
      selectedValues={categories.filter((cat) => value.includes(cat._id))}
      onSelectionChange={(items) => onChange(items.map((item) => item._id))}
      fetchOptions={async () => categories}
      getOptionLabel={(option) => option.name}
      compareOptions={(a, b) => a._id === b._id}
      debounceDelay={0} 
      clearOptionsOnEmptyQuery={false}
      sx={{ mb: 2 }}
    />
  );
}
